// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__uxG3s","input":"index_input__gX2F7","suffix":"index_suffix__Jq_40"};